// =============================================================================
// Piece 2: 广告点击 ID 抓取 — GCLID / GBRAID / WBRAID / MSCLKID
// =============================================================================
(function () {
    function readCookie(name) {
        try {
            var m = document.cookie.match('(?:^|;\\s*)' + name.replace(/[[\]{}()*+?.\\^$|]/g, '\\$&') + '=([^;]*)');
            return m ? decodeURIComponent(m[1]) : '';
        } catch (e) {
            return '';
        }
    }

    function writeCookie(name, value, days) {
        var exp = new Date(Date.now() + days * 864e5).toUTCString();
        var secure = location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + exp + '; path=/; SameSite=Lax' + secure;
    }

    function extractGcl(cookieName) {
        var raw = readCookie(cookieName);
        if (!raw) return '';
        var parts = raw.split('.');
        return parts.length >= 3 ? parts.slice(2).join('.') : '';
    }

    function makeGetter(param, gclCookie, fhpCookie) {
        return function () {
            var v = new URLSearchParams(location.search).get(param);
            if (v) { writeCookie(fhpCookie, v, 90); return v; }
            return (gclCookie ? extractGcl(gclCookie) : '') || readCookie(fhpCookie);
        };
    }

    window._fhpClickId = {
        readCookie:  readCookie,
        getGclid:    makeGetter('gclid',   '_gcl_aw', '_fhp_gclid'),
        getGbraid:   makeGetter('gbraid',  '_gcl_gb', '_fhp_gbraid'),
        getWbraid:   makeGetter('wbraid',  '_gcl_wb', '_fhp_wbraid'),
        getMsclkid:  makeGetter('msclkid', null,      '_msclkid')
    };

    window._fhpClickId.getGclid();
    window._fhpClickId.getGbraid();
    window._fhpClickId.getWbraid();
    window._fhpClickId.getMsclkid();
})();

// =============================================================================
// Piece 1 & 3: HubspotForm 自定义元素
// =============================================================================
class HubspotForm extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector('form');
        this.submit = this.querySelector('button');
        this.url = this.dataset.url;
        this._submitting = false;
        if (!this.form || !this.submit) return;

        ['gclid', 'msclkid'].forEach(key => {
            if (!this.form.querySelector(`[name="${key}"]`)) {
                const input = Object.assign(document.createElement('input'), { type: 'hidden', name: key, value: '' });
                this.form.appendChild(input);
            }
        });

        this._bound = this.handleForm.bind(this);
        this.submit.addEventListener('click', this._bound);
        this.form.addEventListener('submit', this._bound);
    }

    disconnectedCallback() {
        if (this._bound) {
            this.submit?.removeEventListener('click', this._bound);
            this.form?.removeEventListener('submit', this._bound);
        }
    }

    async handleForm(e) {
        e?.preventDefault?.();
        if (this._submitting || !this.url) return;
        if (!this.form.checkValidity()) { this.form.reportValidity(); return; }

        this._submitting = true;

        const ids = window._fhpClickId || {};
        const setVal = (name, fn) => {
            const el = this.form.querySelector(`[name="${name}"]`);
            if (el && typeof fn === 'function') el.value = fn();
        };
        setVal('gclid', ids.getGclid);
        setVal('msclkid', ids.getMsclkid);

        const fields = this.getFields();
        if (!fields?.length) { this._submitting = false; return; }

        const hutk = ids.readCookie ? ids.readCookie('hubspotutk') : '';
        const payload = {
            fields,
            context: { pageUri: location.href, pageName: document.title, ...(hutk && { hutk }) }
        };

        const btnText = this.submit.textContent;
        this.submit.disabled = true;
        this.submit.textContent = 'SENDING...';

        try {
            const res = await fetch(this.url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (res.ok) { this.showSuccess(); return; }
            console.error('[HubSpot Error]', await res.json().catch(() => ({})));
            alert('Submission failed. Please try again.');
        } catch (err) {
            console.error('[HubSpot Network Error]', err);
            alert('A network error occurred. Please try again.');
        }
        this.submit.disabled = false;
        this.submit.textContent = btnText || 'SUBMIT';
        this._submitting = false;
    }

    showSuccess() {
        const val = name => this.form.querySelector(`[name="${name}"]`)?.value?.trim() || '';
        const ids = window._fhpClickId || {};
        const get = fn => typeof fn === 'function' ? fn() : '';

        let firstName = val('firstname'), lastName = val('lastname');
        const fullName = val('fullname');
        if (fullName && !firstName && !lastName) {
            const parts = fullName.split(/\s+/);
            firstName = parts[0] || '';
            lastName = parts.slice(1).join(' ') || '';
        }

        let phone = val('phone').replace(/[^\d+]/g, '');
        if (phone && !phone.startsWith('+')) {
            if (phone.length === 10) phone = '+1' + phone;
            else if (phone.length === 11 && phone.startsWith('1')) phone = '+' + phone;
        }

        let formTopic = 'General Inquiry';
        const sel = document.querySelector('.contact-select-form');
        if (sel?.selectedIndex >= 0 && sel.options[sel.selectedIndex]?.value !== 'regarding') {
            formTopic = sel.options[sel.selectedIndex].text.trim();
        } else {
            formTopic = document.querySelector('.section-banner-page .title, .section-banner-page h1, .section-banner-page h2')?.textContent?.trim()
                || this.closest('.section-contact')?.querySelector('.title h2')?.textContent?.trim()
                || formTopic;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'hubspot_form_success',
            event_category: 'Engagement',
            form_id: this.url ? this.url.split('/').pop().split('?')[0] : '',
            form_topic: formTopic,
            form_page: location.pathname,
            gclid:   val('gclid')   || get(ids.getGclid),
            gbraid:  get(ids.getGbraid),
            wbraid:  get(ids.getWbraid),
            msclkid: val('msclkid') || get(ids.getMsclkid),
            user_data: {
                email: val('email'),
                phone_number: phone || val('phone'),
                address: {
                    first_name: firstName, last_name: lastName,
                    city: val('city'), region: val('state'),
                    postal_code: val('zip'), country: val('country')
                },
                company: val('company')
            },
            form_email: val('email')
        });

        this.form.reset();
        const msg = this.querySelector('.ajax-success-message');
        if (msg) { msg.style.display = 'block'; this.form.style.display = 'none'; }
        else alert('Thank you! Your message has been sent.');
    }

    getFields() {
        const skip = new Set(['privacy-police', 'privacy-policy', 'form_type', 'utf8', 'gbraid', 'wbraid']);
        const arr = [];
        for (const [key, value] of new FormData(this.form).entries()) {
            if (skip.has(key)) continue;
            if ((key === 'gclid' || key === 'msclkid') && !value?.trim()) continue;
            if (key === 'fullname') {
                const parts = value.trim().split(/\s+/);
                if (parts[0]) arr.push({ name: 'firstname', value: parts[0] });
                if (parts.length > 1) arr.push({ name: 'lastname', value: parts.slice(1).join(' ') });
            } else {
                arr.push({ name: key, value: value.trim() });
            }
        }
        return arr;
    }
}
customElements.define('hubspot-form', HubspotForm);